<template>
  <div>
    <b-modal id="modalDialupService" ref="modalDialupService" :title="$t('Dial-up service')" hide-footer size="lg" @shown="shown">
      <div v-if="editItem  && (serviceType === 5)">
        <b-tabs pills card vertical>
          <b-tab :title="$t('Main')">
            <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
              <b-form-input type="text" disabled v-model="editItem.service_data.parent_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
              <b-form-invalid-feedback id="inputFeedbackName">
                {{ $t('Enter title') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.service_data.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="suppliertList" v-model="editItem.service_data.invoice_sup_id"/>
            </b-form-group>
            <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
              <b-form-checkbox v-model="editItem.service_data.link_by_default" value=1 unchecked-value=0>{{ $t('Attach by default') }}</b-form-checkbox>
              <b-form-checkbox v-model="editItem.service_data.multiple_linking" value=1 unchecked-value=0>{{ $t('Allow multiple linking') }}</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Service parameters')">
            <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" :disabled="editItem.service_data.links_count !== 0" v-model="editItem.periodic_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.periodic_service_data.cost !== ''"/>
              <b-form-invalid-feedback id="inputFeedbackCost">
                {{ $t('Enter cost') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="chargeMethodList" v-model="editItem.periodic_service_data.charge_method"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="policyList" v-model="editItem.periodic_service_data.policy_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="schemeList" v-model="editItem.periodic_service_data.scheme_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="contractList" v-model="editItem.service_data.contract_type"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Pool name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="ipPoolsList" v-model="editItem.dialup_service_data.pool_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Maximum timeout')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.dialup_service_data.max_timeout"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Limit of simultaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem.periodic_service_data.radius_sessions_limit"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Login prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.dialup_service_data.login_prefix"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Dinamic IP address allocation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="editItem.service_data.is_dynamic" value="1" unchecked-value="0"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Prices per hour')">
            <b-row>
              <b-col>
                <md-button class="md-raised md-dense" @click="swohAddTimeRange">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="editItem.dialup_service_data.costs" :fields="timeRangeFields"
              @row-dblclicked="EditTimeRangeDblClick">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditTimeRangeButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteTimeRange(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Radius parameters')">
            <b-row>
              <b-col>
                <md-button class="md-raised md-dense" @click="swohAddRadiusAttr">{{ $t('Add') }}</md-button>
              </b-col>
            </b-row>
            <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields"
                  @row-dblclicked="editRadiusAttrDblClick">
              <template v-slot:cell(actions)="row">
                <i @click.stop="ClickOnEditRadiusAttrButton(row)" class="primary fa fa-edit fa-lg"/>
                <i @click.stop="deleteRadiusAttr(row)" class="danger fa fa-trash-alt fa-lg"/>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <modal-ok-cancel @save="saveDialupService" @cancel="$refs.modalDialupService.hide" size="lg"/>
      </div>
    </b-modal>

    <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange">
      <b-form-group label-align="right" :label="$t('Time range')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-select :options="timeRangeList" v-model="selectTimeRange" :disabled="isEditTimeRange"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Cost per hour')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="number" v-model="newTimeRange.cost"/>
      </b-form-group>

        <modal-ok-cancel @save="saveTimeRange" @cancel="hideModalTimeRange" />
    </b-modal>

    <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
      <FormRadiusAttributs
      @edited="editRadiusAttr"
      @hideAddRadiusAttr="hideAddRadiusAttr"
      :isEditRadiusAttr="isEditRadiusAttr"
      :rowRadiusAttr="rowRadiusAttr"
      :radiusAttrItems="radiusAttrItems"/>
    </b-modal>
  </div>
</template>

<script>
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'
export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    schemeList: null,
    serviceType: null,
    timeRangeList: null,
    ipPoolsList: null,
    policyList: null,
    suppliertList: null,
    contractList: null,
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    editItem: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      newTimeRange: {
        'cost': 0,
        'time_range_name': '',
        'time_range_id': 0
      },
      emptyTimeRange: {
        'cost': 0,
        'time_range_name': '',
        'time_range_id': 0
      },
      radiusAttrItems: [],
      rowRadiusAttr: null,
      isEditTimeRange: false,
      selectTimeRange: 1,
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      isEditRadiusAttr: false,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      timeRangeFields: [
        {key: 'time_range_id', label: this.$i18n.t('Time range ID'), sortable: true},
        {key: 'time_range_name', label: this.$i18n.t('Time range name'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Cost per hour'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      radItemForEdit: null
    }
  },
  methods: {
    swohAddTimeRange () {
      this.newTimeRange = JSON.parse(JSON.stringify(this.emptyTimeRange))
      this.isEditTimeRange = false
      this.$refs.modalTimeRange.show()
    },
    EditTimeRangeDblClick (item) {
      this.isEditTimeRange = true
      this.newTimeRange = JSON.parse(JSON.stringify(item))
      this.selectTimeRange = this.newTimeRange.time_range_id
      this.$refs.modalTimeRange.show()
    },
    ClickOnEditTimeRangeButton (row) {
      this.isEditTimeRange = true
      this.newTimeRange = JSON.parse(JSON.stringify(row.item))
      this.selectTimeRange = this.newTimeRange.time_range_id
      this.$refs.modalTimeRange.show()
    },
    hideModalTimeRange () {
      this.$refs.modalTimeRange.hide()
    },
    saveTimeRange () {
      if (!this.newTimeRange.cost) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid sum format'), 'Error')
        return
      }
      this.newTimeRange.cost = Number(this.newTimeRange.cost)
      if (!this.isEditTimeRange) {
        for (let el of this.editItem.dialup_service_data.costs) {
          if (el.time_range_id === this.selectTimeRange) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
            return
          }
        }
        this.newTimeRange.time_range_id = this.selectTimeRange
        for (let el of this.$store.getters['Tariffing/TIME_RANGE']) {
          if (el.tr_id === this.selectTimeRange) {
            this.newTimeRange.time_range_name = el.name
          }
        }
        this.editItem.dialup_service_data.costs.push(this.newTimeRange)
      } else {
        for (let el of this.editItem.dialup_service_data.costs) {
          if (this.selectTimeRange === el.time_range_id) {
            el.cost = this.newTimeRange.cost
          }
        }
      }
      this.hideModalTimeRange()
    },
    deleteTimeRange (row) {
      this.editItem.dialup_service_data.costs = this.editItem.dialup_service_data.costs.filter((value) => {
        return value !== row.item
      })
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttrDblClick (item) {
      this.rowRadiusAttr = item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.radItemForEdit = row
      this.rowRadiusAttr = JSON.parse(JSON.stringify(row.item))
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    editRadiusAttr (radAttr) {
      if (this.radItemForEdit.item) {
        this.radiusAttrItems[this.radItemForEdit.index] = radAttr
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.radiusAttrItems))
      }
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== row.item
      })
    },
    saveDialupService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (!this.editItem.dialup_service_data.costs.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Prices per hour table is empty'), 'Error')
        return
      }
      if (!this.editItem.dialup_service_data.max_timeout) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Maximum timeout field is invalid'), 'Error')
        return
      }

      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.editItem.service_data.parent_id === 0) this.editItem.service_data.parent_id = -1
        this.editItem.service_data.link_by_default = Number(this.editItem.service_data.link_by_default)
        this.editItem.service_data.multiple_linking = 'multiple_linking' in this.editItem.service_data ? this.editItem.service_data.multiple_linking : 0
        this.editItem.service_data.multiple_linking = Number(this.editItem.service_data.multiple_linking)
      }
      if (this.isTariffPlan) {
        this.editItem.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      this.editItem.periodic_service_data.cost = Number(this.editItem.periodic_service_data.cost)
      this.editItem.dialup_service_data.max_timeout = Number(this.editItem.dialup_service_data.max_timeout)
      this.editItem.periodic_service_data.radius_sessions_limit = Number(this.editItem.periodic_service_data.radius_sessions_limit)
      this.editItem.service_data.is_dynamic = Number(this.editItem.service_data.is_dynamic)
      let ipPool = this.ipPoolsList.find(el => {
        return el.value === this.editItem.dialup_service_data.pool_id
      })
      this.editItem.dialup_service_data.pool_name = ipPool ? ipPool.text : ''
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_DIALUP_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_DIALUP_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalDialupService.hide()
          this.$root.$emit('makeToasts')

          let sid = this.isEdit ? this.editItem.service_data.service_id : response.data.service_id

          let invID = this.editItem.service_data.invoice_sup_id ? this.editItem.service_data.invoice_sup_id : 0
          this.$store.dispatch('Tariffing/UPDATE_SUPPLIER_ID', {service_id: sid, invoice_sup_id: invID})

          this.$store.dispatch('Tariffing/UPDATE_CHARGE_POLICY', {service_id: sid, policy_id: this.editItem.periodic_service_data.policy_id})

          if (this.isTemplates || this.isTariffPlan) {
            let ml = this.editItem.service_data.multiple_linking ? this.editItem.service_data.multiple_linking : 0
            this.$store.dispatch('Tariffing/UPDATE_MULTI_LINKING', {service_id: sid, multiple_linking: ml})
          }

          this.$store.dispatch('Tariffing/UPDATE_RADIUS_ATTR', {set_object_id: sid, set_type: 5, attrs: this.radiusAttrItems})
        }
      })
    },
    shown () {
      if (this.editItem.dialup_service_data.pool_name) {
        let ipPool = this.ipPoolsList.find(el => {
          return el.text === this.editItem.dialup_service_data.pool_name
        })
        this.editItem.dialup_service_data.pool_id = ipPool ? ipPool.value : 0
      }
      if (this.isEdit || this.isTariffPlan) {
        this.radiusAttrItems = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/RADIUS_ATTR_SERVICES']))
        for (let el of this.radiusAttrItems) {
          el.value = el.attr_value
          if (el.tag && (el.vendor === 0)) {
            el.value = ':' + el.tag + ':' + el.attr_value
          }
          switch (el.attr_type) {
            case 1:
              el.attrType = this.$i18n.t('Number')
              break
            case 2:
              el.attrType = this.$i18n.t('String')
              break
            case 3:
              el.attrType = 'IP'
              break
            case 4:
              el.attrType = this.$i18n.t('Binary')
              break
          }
        }
      } else {
        this.radiusAttrItems = []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formDialupService.vue